<div
  class="profile__container"
  [ngClass]="{ 'profile__container--current': selfUserEdit() }"
>
  @if (showClose()) {
  <app-close-button
    [hasChanges]="(form.dirty && form.valid) || roleChanged()"
    (closed)="closeDialog()"
    (confirmClosed)="showConfirmationDialog()"
  ></app-close-button>
  } @if (selfUserEdit()) {
  <div class="profile__email">
    {{ authStore.currentUser()?.email }}
  </div>
  }
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="profile__form">
    <app-avatar
      [userName]="
        selfUserEdit()
          ? authStore.currentUser()!.fullName
          : store.tempUser()!.fullName
      "
      [size]="'big'"
      class="avatar"
    ></app-avatar>

    @if (!selfUserEdit()) {
    <button
      mat-button
      [matMenuTriggerFor]="menu"
      (click)="$event.stopPropagation()"
      (keydown.enter)="$event.stopPropagation()"
      type="button"
      class="role-button"
    >
      <app-role-info
        [role]="form.controls.userRole.value"
        [noBackground]="true"
      ></app-role-info>
    </button>
    <mat-menu #menu="matMenu">
      @for (role of rolesStore.entities(); track role.id) {
      <button
        mat-menu-item
        (click)="form.controls.userRole.setValue(role); roleChanged.set(true)"
        [disabled]="form.controls.userRole.value.id === role.id"
        class="role-menu-item"
      >
        <app-role-info
          [role]="role"
          [roleSelected]="form.controls.userRole.value.id === role.id"
          [noBackground]="true"
          [icon]="{
            background: 'transparent',
            color: 'var(--mat-sys-on-surface)'
          }"
          [textColor]="'var(--mat-sys-on-surface)'"
        ></app-role-info>
      </button>
      }
    </mat-menu>
    } @else {
    <app-role-info
      [role]="authStore.currentUser()?.userRole"
      [noBackground]="true"
      class="role-without-button"
    ></app-role-info>
    }

    <div class="name-controls">
      <mat-form-field appearance="outline" hideRequiredMarker>
        <mat-label>{{ 'name' | translate | async }}</mat-label>
        <input
          matInput
          formControlName="firstName"
          (click)="$event.stopPropagation()"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" hideRequiredMarker>
        <mat-label>{{ 'surname' | translate | async }}</mat-label>
        <input
          matInput
          formControlName="lastName"
          (click)="$event.stopPropagation()"
        />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="phone-number">
      <mat-label>{{ 'phone' | translate | async }}</mat-label>
      <input
        matInput
        formControlName="phoneNumber"
        (click)="$event.stopPropagation()"
        (keydown.enter)="$event.stopPropagation()"
      />
      @if (form.controls.phoneNumber.invalid ||
      form.controls.phoneNumber.hasError('duplicatedPhone')) {
      <mat-error> {{ 'duplicatedPhone' | translate | async }} </mat-error>
      }
    </mat-form-field>

    @if (selfUserEdit()) {
    <button
      mat-button
      type="button"
      class="change-password-button"
      (click)="
        store.openChangePasswordDialog(dialogRef!); $event.stopPropagation()
      "
      (keydown.enter)="$event.stopPropagation()"
    >
      {{ 'changeYourPassword' | translate | async }}</button
    >
    }

    <button
      mat-flat-button
      type="submit"
      [disabled]="form.invalid || (!form.dirty && !roleChanged())"
      class="save-button"
    >
      {{ 'save' | translate | async }}
    </button>
  </form>
</div>
